import styles from './UserNotFound.module.scss';
import { Text } from '../components/typography';

const constructionPng =
  'https://app.opasmobile.com/assets/graphics/gear_and_wrench.png';
export default function UserNotFound() {
  return (
    <div className={styles.container}>
      <img
        className={styles.image}
        src={constructionPng}
        alt="construction-graphic"
      />
      <Text weight="bold" size="xl">
        We're Updating 🛠️
      </Text>
      <Text weight="semiBold" size="lg" textAlign="center">
        Our team is working hard to bring you new features and improvements, be
        back soon 🚀
      </Text>
      <Text weight="semiBold">
        If you have urgent questions, please contact us{' '}
        <a href="mailto:support@opasmobile.com">here</a>
      </Text>
      <Text weight="semiBold" color="secondary">
        Thank you for your patience!
      </Text>
    </div>
  );
}
